export default __webpack_public_path__ + "static/media/NCL.a33bfaa6.png";